// Enumerations
// Types
import { ProofIncomeStatesEnumeration } from 'containers/proof-income/enumerations/proof-income-states.enumeration';
import {
  ProofIncomeErrorBuilderHandlersType,
  ProofIncomeErrorMethodsHandlersType,
} from './types/proof-income-error.handlers.type';

const resetProofOfIncomeFlowButtonClickHandler = ({
  handleTrackTryAgain,
  setError,
  setProofIncomeState,
}: ProofIncomeErrorBuilderHandlersType): void => {
  handleTrackTryAgain();
  setError(false);
  setProofIncomeState(ProofIncomeStatesEnumeration.LANDING);
};

const ProofIncomeErrorHandlers = (
  props: ProofIncomeErrorBuilderHandlersType
): ProofIncomeErrorMethodsHandlersType => ({
  handleResetProofOfIncomeFlowButtonClick: () => resetProofOfIncomeFlowButtonClickHandler(props),
});

export { ProofIncomeErrorHandlers };
